// Strip clip tracks that can't drive the preview rig — mirrors AvatarModel's
// pruneUnbindableTracks: drop root/Armature entirely (foreign axis/scale would
// tip or shrink the whole rig), drop pelvis scale, keep only rig-bound tracks.
const STRIP_ALL = new Set(['root', 'Armature'])
const STRIP_SCALE = new Set(['pelvis'])

export function pruneClipTracks(tracks, nodeNames) {
  return tracks.filter((track) => {
    const dot = track.name.lastIndexOf('.')
    const nodePath = dot >= 0 ? track.name.slice(0, dot) : track.name
    const prop = dot >= 0 ? track.name.slice(dot + 1) : ''
    const leaf = nodePath.split('/').pop()
    if (STRIP_ALL.has(leaf)) return false
    if (STRIP_SCALE.has(leaf) && prop === 'scale') return false
    return nodeNames.has(leaf)
  })
}
